'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disabledScrollClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SelectPopover = require('./SelectPopover');

var _SelectPopover2 = _interopRequireDefault(_SelectPopover);

var _SelectButton = require('./SelectButton');

var _SelectButton2 = _interopRequireDefault(_SelectButton);

var _SelectOption = require('./SelectOption');

var _SelectOption2 = _interopRequireDefault(_SelectOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var disabledScrollClass = exports.disabledScrollClass = 'ui-disabledScroll';

var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
    NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;

/**
 * The Select component. The only exported component.
 */

var Select = function (_PureComponent) {
    _inherits(Select, _PureComponent);

    _createClass(Select, null, [{
        key: 'toggleElementClass',
        value: function toggleElementClass(element, className, enabled) {
            // IE 11 doesn't support second parameter in classList.toggle
            if (enabled) {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        }
    }, {
        key: 'toggleDisabledScrollClass',
        value: function toggleDisabledScrollClass(enabled) {
            Select.toggleElementClass(document.querySelector('html'), disabledScrollClass, enabled);
            Select.toggleElementClass(document.body, disabledScrollClass, enabled);
        }
    }, {
        key: 'getOptionProp',
        value: function getOptionProp(option, getter) {
            if ((0, _lodash.isString)(getter) || (0, _lodash.isArray)(getter)) {
                return (0, _lodash.get)(option, getter);
            }

            if ((0, _lodash.isFunction)(getter)) {
                return getter(option);
            }

            return null;
        }
    }]);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.renderNoOptions = function () {
            var _this$props = _this.props,
                noOptionsRenderer = _this$props.noOptionsRenderer,
                noOptionsMessage = _this$props.noOptionsMessage;


            if (noOptionsRenderer) return noOptionsRenderer();

            return _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__icon' },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    noOptionsMessage
                )
            );
        };

        _this.state = {
            popoverOpen: false,
            query: ''
        };
        _this.startPagePositionTop = null;

        _this.handlePageClick = _this.handlePageClick.bind(_this);
        _this.handleBreakpointChange = _this.handleBreakpointChange.bind(_this);

        _this.closePopover = _this.closePopover.bind(_this);
        _this.togglePopover = _this.togglePopover.bind(_this);

        _this.clearSelection = _this.clearSelection.bind(_this);

        _this.handleButtonClick = _this.handleButtonClick.bind(_this);
        _this.handleOptionClick = _this.handleOptionClick.bind(_this);

        _this.handleQueryChange = _this.handleQueryChange.bind(_this);

        _this.getOptionLabel = _this.getOptionLabel.bind(_this);
        _this.getOptionValue = _this.getOptionValue.bind(_this);
        _this.isOptionSelected = _this.isOptionSelected.bind(_this);
        _this.renderButtonLabel = _this.renderButtonLabel.bind(_this);
        _this.renderButtonOption = _this.renderButtonOption.bind(_this);
        _this.renderOption = _this.renderOption.bind(_this);
        return _this;
    }

    _createClass(Select, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('click', this.handlePageClick, false);
            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('click', this.handlePageClick, false);
            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);

            if (this.isPopoverOpen()) {
                this.closePopover();
            }
        }
    }, {
        key: 'getRenderingOptions',
        value: function getRenderingOptions() {
            var _this2 = this;

            var _props = this.props,
                options = _props.options,
                optionsSorter = _props.optionsSorter;
            var _state$query = this.state.query,
                query = _state$query === undefined ? '' : _state$query;

            return (optionsSorter === null ? _lodash.identity : _lodash.sortBy)(!query ? options : options.filter(function (option) {
                return _this2.props.optionsQueryComparator(_this2.getOptionLabel(option), query);
            }), optionsSorter || function (option) {
                return _this2.getOptionLabel(option).toLowerCase();
            });
        }
    }, {
        key: 'getOptionValue',
        value: function getOptionValue(option) {
            return Select.getOptionProp(option, this.props.valueGetter);
        }
    }, {
        key: 'getOptionLabel',
        value: function getOptionLabel(option) {
            return Select.getOptionProp(option, this.props.labelGetter);
        }
    }, {
        key: 'isOptionSelected',
        value: function isOptionSelected(option) {
            var currentValue = this.getOptionValue(option);
            if ((0, _lodash.isArray)(this.props.value)) {
                return this.props.value.indexOf(currentValue) >= 0;
            }
            return currentValue === this.props.value;
        }
    }, {
        key: 'isPopoverOpen',
        value: function isPopoverOpen() {
            return this.state.popoverOpen;
        }
    }, {
        key: 'togglePopover',
        value: function togglePopover() {
            var popoverOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.isPopoverOpen();

            this.setState({
                popoverOpen: popoverOpen
            });

            this.togglePageScroll(popoverOpen, _rpMqBreakpoints2.default.current().code);
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.togglePopover(false);
        }
    }, {
        key: 'clearSelection',
        value: function clearSelection(e, value) {
            e.stopPropagation();

            if (this.props.disabled) {
                return;
            }

            var result = this.props.multiSelect ? this.props.value.filter(function (item) {
                return item !== value;
            }) : null;

            this.props.onChange(result);
        }
    }, {
        key: 'togglePageScroll',
        value: function togglePageScroll(popoverOpen, breakpointCode) {
            if (popoverOpen && [EXTRA_NARROW, NARROW].indexOf(breakpointCode) > -1) {
                this.disablePageScroll();
            } else {
                this.enablePageScroll();
            }
        }
    }, {
        key: 'enablePageScroll',
        value: function enablePageScroll() {
            Select.toggleDisabledScrollClass(false);

            if (this.startPagePositionTop !== null) {
                var windowPageYOffset = this.rootRef.getBoundingClientRect().top - this.startPagePositionTop + window.pageYOffset;
                this.startPagePositionTop = null;
                window.setTimeout(function () {
                    window.scrollTo(window.pageXOffset, windowPageYOffset);
                }, 0);
            }
        }
    }, {
        key: 'disablePageScroll',
        value: function disablePageScroll() {
            this.startPagePositionTop = this.rootRef.getBoundingClientRect().top;

            Select.toggleDisabledScrollClass(true);
        }
    }, {
        key: 'handleBreakpointChange',
        value: function handleBreakpointChange(e) {
            if (this.isPopoverOpen()) {
                this.togglePageScroll(true, e.detail.breakpoint.code);
            }
        }
    }, {
        key: 'handleSingleOptionClick',
        value: function handleSingleOptionClick(value, option) {
            this.props.onChange(value, option);
            this.closePopover();
        }
    }, {
        key: 'handleMultiOptionClick',
        value: function handleMultiOptionClick(value, option) {
            this.props.onChange(value, option);
        }
    }, {
        key: 'handleOptionClick',
        value: function handleOptionClick(value, option) {
            var _props2 = this.props,
                onChange = _props2.onChange,
                multiSelect = _props2.multiSelect;

            onChange(value, option);
            if (!multiSelect) {
                this.closePopover();
            }
        }
    }, {
        key: 'handleQueryChange',
        value: function handleQueryChange(query) {
            this.setState({ query: query });
        }
    }, {
        key: 'handlePageClick',
        value: function handlePageClick(e) {
            if (this.isPopoverOpen() && !this.rootRef.contains(e.target)) {
                this.closePopover();
            }
        }
    }, {
        key: 'handleButtonClick',
        value: function handleButtonClick() {
            this.togglePopover();
        }
    }, {
        key: 'renderButtonOption',
        value: function renderButtonOption(value) {
            var _this3 = this;

            var option = this.props.options.find(function (item) {
                return _this3.getOptionValue(item) === value;
            });
            return _react2.default.createElement(
                'span',
                { className: 'sb-select__button__label_flag', key: value },
                _react2.default.createElement(
                    'span',
                    { className: 'sb-select__button__label' },
                    this.getOptionLabel(option)
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: 'sb-select__button__label_flagClose',
                        onClick: function onClick(e) {
                            return _this3.clearSelection(e, value);
                        }
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Small' })
                )
            );
        }
    }, {
        key: 'renderButtonLabel',
        value: function renderButtonLabel() {
            var _props3 = this.props,
                multiSelect = _props3.multiSelect,
                value = _props3.value,
                placeholder = _props3.placeholder;


            if ((0, _lodash.isNil)(value) || multiSelect && !value.length) {
                return placeholder;
            }

            return multiSelect ? value.map(this.renderButtonOption) : this.renderButtonOption(value);
        }
    }, {
        key: 'renderOption',
        value: function renderOption(option) {
            var _this4 = this;

            return _react2.default.createElement(_SelectOption2.default, {
                key: this.getOptionValue(option),
                option: option,
                labelGetter: this.getOptionLabel,
                valueGetter: this.getOptionValue,
                isSelected: this.isOptionSelected,
                immediateUpdate: this.props.multiSelect,
                onClick: function onClick(value, valueOption) {
                    _this4.handleOptionClick(value, valueOption);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props4 = this.props,
                title = _props4.title,
                disabled = _props4.disabled,
                alphabet = _props4.alphabet,
                showSearch = _props4.showSearch,
                onPopoverDidOpen = _props4.onPopoverDidOpen,
                multiSelect = _props4.multiSelect,
                options = _props4.options,
                rowHeight = _props4.rowHeight,
                dropdownListHeight = _props4.dropdownListHeight;
            var query = this.state.query;

            return _react2.default.createElement(
                'div',
                {
                    className: 'sb-select ' + (multiSelect ? 'sb-select_multi' : ''),
                    ref: function ref(_ref) {
                        return _this5.rootRef = _ref;
                    }
                },
                _react2.default.createElement(_SelectButton2.default, {
                    label: this.renderButtonLabel(),
                    major: this.isPopoverOpen(),
                    disabled: disabled,
                    onClick: this.handleButtonClick
                }),
                this.isPopoverOpen() ? _react2.default.createElement(_SelectPopover2.default, {
                    title: title,
                    alphabet: alphabet,
                    showSearch: showSearch && options.length > 0,
                    query: query,
                    rowHeight: rowHeight,
                    options: this.getRenderingOptions(),
                    optionLabelGetter: this.getOptionLabel,
                    optionRenderer: function optionRenderer(opt) {
                        return _this5.renderOption(opt);
                    },
                    noOptionsRenderer: this.renderNoOptions,
                    onQueryChange: this.handleQueryChange,
                    onClose: this.closePopover,
                    onDidMount: onPopoverDidOpen,
                    dropdownListHeight: dropdownListHeight
                }) : null
            );
        }
    }]);

    return Select;
}(_react.PureComponent);

Select.propTypes = {
    /**
     * Title to be displayed in popover on mobile devices
     */
    title: _react.PropTypes.string.isRequired,
    /**
     * Placeholder to be displayed while no value selected
     */
    placeholder: _react.PropTypes.string,
    /**
     * Disables the component
     */
    disabled: _react.PropTypes.bool,
    /**
     * Select should be used as a controlled component.
     * This property sets it's value.
     */
    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.array]),
    /**
     * This property allows multiple options to be selected..
     */
    multiSelect: _react.PropTypes.bool,
    /**
     * Options to be rendered in open popover.
     * It should have structure [{ label: 'Option Label', value: 'optionValue' }] by default.
     * Options with custom structure are acceptable too (see 'labelGetter' and 'valueGetter' for details).
     */
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
    /**
     * Shows alphabet in popover.
     * It could be boolean if you want to control the visibility of the default (English) alphabet.
     * You can also provide a string with custom chars to be rendered instead of default alphabet.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
    /**
     * Controls the visibility of search input in popover.
     */
    showSearch: _react.PropTypes.bool,
    /**
     * Controls height of row element, defaults to 64px
     */
    rowHeight: _react.PropTypes.number,
    /**
     * Controls height of options list into dropdown (for medium and larger screens),
     */
    dropdownListHeight: _react.PropTypes.number,
    /**
     * You can set custom option label getter if you have custom option object structure.
     * By default, it is 'label'.
     * It uses _.get for string and array label getter.
     * You also can pass a function which accepts option object as a parameter and returns string label.
     * For example, ({ name }) => name
     */
    labelGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
    /**
     * You can set custom option value getter if you have custom option object structure.
     * By default it is 'value'.
     * It uses _.get for string and array value getter.
     * You also can pass a function which accepts option object as a parameter and returns value.
     * For example, ({ id }) => id
     */
    valueGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
    /**
     * By default options are sorted by labels in alphabet order.
     * You can override default sorting with this property.
     * It uses _.sortBy API.
     * Pass null if you want to disable sorting.
     */
    optionsSorter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
    /**
     * Comapring option and filter query
     */
    optionsQueryComparator: _react.PropTypes.func,
    /**
     * Message to render if no options available (due to search query or any other reason).
     * It is ignored if noOptionsRenderer is set.
     */
    noOptionsMessage: _react.PropTypes.string,
    /**
     * Function that renders the placeholder if no options available (due to search query or any other reason)
     */
    noOptionsRenderer: _react.PropTypes.func,
    /**
     * Select should be used as a controlled component.
     * You should handle change event with this property to change component value.
     */
    onChange: _react.PropTypes.func.isRequired,
    /**
     * You can handle popover open with this property.
     * If your handler returns Promise, component will render the Spinne while promise unresolved.
     * It could be used to load options asynchronously.
     */
    onPopoverDidOpen: _react.PropTypes.func
};

Select.defaultProps = {
    value: null,
    placeholder: 'Select',
    labelGetter: 'label',
    valueGetter: 'value',
    noOptionsMessage: 'No results',
    noOptionsRenderer: null,
    optionsQueryComparator: function optionsQueryComparator(optionLabel, query) {
        return optionLabel.toLowerCase().indexOf(query.toLowerCase()) > -1;
    }
};

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/Select.js
// module id = 1339
// module chunks = 1